import BasePlugin from './base-plugin'
import { vjs_El } from './utils'

class LogoPlugin extends BasePlugin {
  constructor(player, options = {}) {
    super(player)

    options = Object.assign({ img: null, url: null, position: 'LT', offsetX: 10, offsetY: 10 }, options)

    if (options.img === null) {
      return
    }

    const e = vjs_El('div', 'vjs-logo')
    e.style.backgroundImage = `url(${options.img})`

    const i = options.offsetX
    const s = options.offsetY
    if (options.position === 'RT') {
      e.style.right = `${i}px`
      e.style.top = `${s}px`
    }
    else if (options.position === 'LB') {
      e.style.left = `${i}px`
      e.className += ' vjs-logo-bottom'
    }
    else {
      e.style.left = `${i}px`
      e.style.top = `${s}px`
    }
    if (options.url) {
      const a = vjs_El('a')
      a.href = options.url
      a.target = '_blank'
      a.appendChild(e)
      this.playerElement.appendChild(a)
    }
    else {
      this.playerElement.appendChild(e)
    }
  }
}

export default LogoPlugin
